import HeroCarousel from "@/pages/home/components/HeroCarousel";
import CategoryGrid from "@/pages/home/components/CategoryGrid";
import LatestNews from "@/pages/home/components/LatestNews";
import TopicSpotlight from "@/pages/home/components/TopicSpotlight";
import SiteIntro from "@/pages/home/components/SiteIntro";
import { getFocusNews } from "@/utils/news";
import { useDocumentTitle } from "@/hooks/useDocumentTitle";

export default function Home() {
  const focusNews = getFocusNews();

  useDocumentTitle(
    "911爆料 - 最新新闻资讯与深度分析平台",
    "911爆料为您提供及时的爆料新闻和深度报道，涵盖社会热点、事件真相和独家信息，帮助用户第一时间了解最新动态和内幕详情。"
  );

  return (
    <div className="animate-fade-up">
      <HeroCarousel items={focusNews} />
      <CategoryGrid />
      <LatestNews />
      <TopicSpotlight />
      <SiteIntro />
    </div>
  );
}